<script>
import {delLocalItem, filterEmptyParams, getLocalItem, setLocalItem} from "@/untils/common";
import {medium_audioFileNotifyLib} from "@/lib/request";
import {ClientId} from "@/lib/cli";
import axios from 'axios';
import {Dialog} from "vant";
// import OSS from 'ali-oss';
// import {configAli} from '@/untils/common.js'; // 引入你的OSS配置文件
export default {
  name:'medium',
  data(){
    return{
      isAndroid:false,
      isUploading: false,
      uploadProgress: 0,
      // -----
      isRestoring:false,
      savedScrollPosition:0,
      routerFlag:false,
      routerId:'',
      routerTitle:'',
      wordNumber:5,
      formattedTime:'',
      formItemDisabled:false,
      formTimeDisabled:false,
      // 素材类型的icon
      icons : {
        'allIcon': '📋',
        'PICTURE': '🖼️',
        'VIDEO': '🎬',
        'URL': '🌐',
        'PLUGIN': '🧩'
      },
      iconsName: {
        'PICTURE': '图片',
        'VIDEO': '视频',
        'URL': '网页',
        'PLUGIN': '插件',
        'AUDIO': '音频',
        'AI': '数字人回答'
      },
      siteId: '',
      checked: false,
      ridChecked: false,//雷达开关
      autoChecked: false,//自动播放开奖直播
      typeTabIndex: 0,
      searchInput: '',//输入搜索素材名称
      // tab切换-静态数据（静态素材分类列表）
      tabFind: true,
      typeTab: [
        // {},
        {
          name: '官方',
          text: '官方素材库',
          number: 0,
          type: 'allIcon',
          icon: '📋',
          typeList: ["VIDEO", "PICTURE", "URL", "PLUGIN"]
        },
        // {
        //   name: '图片',
        //   text: '图片素材库',
        //   number: 0,
        //   type: 'PICTURE',
        //   icon: '🖼',
        //   typeList: ["PICTURE"]
        // }, {
        //   name: '视频',
        //   text: '视频素材库',
        //   number: 0,
        //   type: 'VIDEO',
        //   icon: '🎬',
        //   typeList: ["VIDEO"]
        // }, {
        //   name: '网页',
        //   text: '网页素材库',
        //   number: 0,
        //   type: 'URL',
        //   icon: '🌐',
        //   typeList: ["URL"]
        // }, {
        //   name: '插件',
        //   text: '插件素材库',
        //   number: 0,
        //   type: 'PLUGIN',
        //   icon: '🧩',
        //   typeList: ["PLUGIN"]
        // },
        {
          name: '自定义',
          text: '自定义素材库',
          number: 0,
          type: 'AUTO',
          icon: '⭐',
          typeList: ["AUTO"]
        }
      ],
      // 查询官方素材类型
      showMaterialOfficialValueParams:{type: ['PICTURE', 'VIDEO','URL','PLUGIN'], name: '全部类型'},
      showMaterialOfficialFlag: false,
      OfficialSingleNameList: [
        {type: ['PICTURE', 'VIDEO','URL','PLUGIN'], name: '全部类型'},
        {type: ['PICTURE'], name: '图片'},
        {type: ['VIDEO'], name: '视频'},
        {type: ['URL'], name: '网页'},
        {type: ['PLUGIN'], name: '插件'},
      ],
      // 3大tab模块
      activeTab: '0',
      //全部库里的素材列表
      page1: 0,
      size1: 20,
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      listDataAll: [
        // {
        //   "id": "871419819910496256",
        //   "createTime": 1754034675283,
        //   "updateTime": 1754034675283,
        //   "name": "七乐彩",
        //   "url": "https://testrobot.joyveb.com/chart-seven",
        //   "type": "URL",
        //   "module": "Marketing",
        //   "contents": [],
        //   "content": null,
        //   "enabled": false
        // },
      ],
      allListInData: [],
      //自行选择完成的素材列表
      playData: [],
      // 开机设置
      timeType: '',
      checkType: '',
      openCloseChecked: false,//定时开关机
      currentTime: '9:00',
      showPicker: false,
      // 一周7天-静态数据
      timeWeekData: [
        {
          title: '周一',
          name: 'MONDAY',
          type: '1',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周二',
          name: 'TUESDAY',
          type: '2',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周三',
          name: 'WEDNESDAY',
          type: '3',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周四',
          name: 'THURSDAY',
          type: '4',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周五',
          name: 'FRIDAY',
          type: '5',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周六',
          name: 'SATURDAY',
          type: '6',
          checked: false,
          startTime: '',
          endTime: '',
        }, {
          title: '周日',
          name: 'SUNDAY',
          type: '7',
          checked: false,
          startTime: '',
          endTime: '',
        }
      ],
      gapValue: 60,
      maxDistinct: 3,
      playbackVolume: 0,
      siteChecked: true,//默认打开
      //上传素材-素材类型
      //编辑素材文案 Customize materials
      // customizeMaterialsFlag
      editCustomizeParams: {},
      customizeMaterialsFlag: false,
      contentsFile: {},
      subDisabled: false,
      // 自定义素材类型
      listCustomTypeData: [
        {type: 'PICTURE', name: '图片'},
        {type: 'VIDEO', name: '视频'},
        // {type:'URL',name:'网页'},
        // {type:'PLUGIN',name:'插件'},
        // {type:'AUDIO',name:'音频'},
        // {type:'AI',name:'数字人回答'},
      ],
      showCustomValueParams: {},
      showCustomTypeFlag: false,
      // 查询自定义-审核状态
      AdmitNameList: [
        {type: '', name: '全部状态'},
        {type: 'Pass', name: '已批准'},
        {type: 'Pending', name: '待审核'},
        {type: 'Failed', name: '已驳回'},
      ],
      showReviewValueParams: {type: '', name: '全部状态'},//默认值//type:'Pass',name:'已批准'
      showReviewFlag: false,
      // 查询自定义素材类型
      SingleNameList: [
        {type: ['PICTURE', 'VIDEO'], name: '全部类型'},
        {type: ['PICTURE'], name: '图片'},
        {type: ['VIDEO'], name: '视频'},
      ],
      showMaterialValueParams: {type: ['PICTURE', 'VIDEO'], name: '全部类型'},
      showMaterialFlag: false,
      // editFlag:false,
      // 文件上传
      fileVideoUrl: '/api/resource/oss/upload',//接口前缀加api
      headers: {
        'isEncrypt': true,
        'Authorization': 'Bearer ' + getLocalItem('access_token'),
        'clientid': ClientId,
      },
      loading: false,
      imgFlag2: false,
      //是否显示进度条
      imgUploadPercent2: 0,
      //进度条的进度，
      isShowUploadImg2: false,
      //显示上传按钮
      imgForm2: {
        showVideoPath: "",  //回显的变量
      },
      fileList: [],
      fileVideoShowUrl: null,
      fileObject: null,
      width: null,
      height: null,
      fileListQr: [],
      qrCode: null,
    }
  },
  components: {

  },
  watch: {
    // 监控参数变化
    searchParams: {
      handler(newVal, oldVal) {
        // 添加变化检测逻辑
        const isNameChanged = newVal.name !== oldVal.name;
        const isTypesChanged = JSON.stringify(newVal.types) !== JSON.stringify(oldVal.types);
        if (isNameChanged || isTypesChanged) {
          this.page1 = 0;
        }
        this.getListData();
      },
      deep: true,
      // immediate: false // 设为 false 避免初始化执行
    },
  },
  computed: {
    type1Count() {
      return this.playData.filter(item => item.typical === 'System').length;
    },
    // 监控参数变化
    searchParams() {
      return {
        networkId: this.siteId,//网点编号
        name: this.searchInput,//按名称搜索
        page: this.page1,//页数
        size: this.size1,//条数
        types: this.typeTabIndex !== 1 ? (this.showMaterialOfficialValueParams.type?this.showMaterialOfficialValueParams.type:[...this.typeTab[this.typeTabIndex].typeList]) : this.showMaterialValueParams.type, // 类型数组
        usageType: this.typeTabIndex !== 1 ? 'General' : 'Personal',//素材使用类型['Personal-个人','General-通用']
        reviewStatus: this.typeTabIndex !== 1 ? '' : this.showReviewValueParams.type,//素材审核状态[待审核Pending,审核通过Pass,审核未通过Failed]
      };
    },
  },
  methods: {
    // async handleFileUpload(event) {
    //   const file = event.target.files[0];
    //   if (!file) {
    //     return;
    //   }
    //   const client = new OSS({
    //     region: configAli.region,
    //     accessKeyId: configAli.accessKeyId,
    //     accessKeySecret: configAli.accessKeySecret,
    //     bucket: configAli.bucket,
    //   });
    //   const result = await client.put(file.name, file); // 上传文件到指定的bucket和文件名（这里是文件名，可以根据需要修改）
    //   console.log('上传成功', result); // 打印上传结果，可以根据需要处理结果，例如更新UI等。
    // },
    onHeadTab(index) {
      // 自行选择的配置项
      if (index === '0') {
        // 素材类型的数量
        this.getTypeNumber();
      } else if (index === '1') {
        this.playData = getLocalItem('inPlayListArr') ? getLocalItem('inPlayListArr') : [];
      } else if (index === '2') {
        // 查询定时开关机配置
        this.getShowTimeData();
        // 雷达功能（开启后可检测周边信号）
        this.getRadarData();
        // 音量大小调节功能
        this.getAudio();
      }
    },
    onTabCurrent(index) {
      if (this.tabFind) {
        this.page1 = 0;
        this.typeTabIndex = index;
        if(index===1){
          this.searchInput = '';
        }
      } else {
        this.$toast('操作过急！');
      }
    },
    // 启用或停用开关，启用加入素材列表
    getOnSwitch(index, item) {
      const itemSystem = this.playData.filter(v => item.id === v.id && v.typical === 'System')
      if (itemSystem && itemSystem[0] && itemSystem[0].id && (item.id === itemSystem[0].id)) {
        item.checked = true;
        this.$toast('系统为您安排的播放配置项');
        return false;
      }
      // 开启开关时
      if (item.checked) {
        let push_arr = [];
        if (getLocalItem('inPlayListArr')) {
          push_arr = getLocalItem('inPlayListArr');
        }
        this.listDataAll.map((v) => {
          if (v.id === item.id) {
            v.checked = true;
            v.enabled = false;
            v.indexSort = this.playData.length + 1;
          }
          if (v.checked) {
            push_arr.push(v);
          }
        });
        // 数组去重
        const uniqueArr = push_arr.filter((item, index, array) => {
          return array.findIndex(obj => obj.id === item.id) === index;
        }).sort((a, b) => a.indexSort - b.indexSort);
        this.playData = uniqueArr;
        setLocalItem('inPlayListArr', uniqueArr);
      } else {
        // 关闭开关时
        this.playData.map((v) => {
          if (v.id === item.id) {
            if (!item.checked) {
              v.checked = false;
            }
          }
        });
        // 数组过滤checked为true的
        const uniqueArr = this.playData.filter(item => item.checked);
        setLocalItem('inPlayListArr', uniqueArr);
      }
    },
    /*
    * 屏保配置
    * 素材查询列表和素材自定义播放配置操作
    * */
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    getListData() {
      this.playData = getLocalItem('inPlayListArr') ? getLocalItem('inPlayListArr') : [];
      this.tabFind = false;
      this.loading1 = true;
      this.finished1 = false;
      if (this.searchParams.page1 === 0) {
        this.listDataAll = [];
      }
      this.$http.medium_marketingMaterialsFindByNetwork(filterEmptyParams(this.searchParams)).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.loading1 = false;
            if (res.data) {
              this.tabFind = true;
              let resData = res.data.rows;
              this.totals1 = res.data.totalRows;
              this.totalPages1 = Math.ceil(res.data.totalRows / this.size1) - 1;
              if (resData == null || resData.length === 0) {
                this.finished1 = true;
                this.listDataAll = [];
                return false;
              } else {
                resData.map((v) => {
                  v.checked = v.enabled;// enabled:ture已发布，false未发布
                  // 如果自定义的配置项列表有，则默认素材列表的项也是开状态
                  this.playData.map((i) => {
                    if (v.id === i.id && i.checked) {
                      v.checked = true;
                      v.typical = i.typical;
                    }
                  });
                  v.value = '';
                });
                if (this.page1 > 0) {
                  this.listDataAll = this.listDataAll.concat(resData);
                } else {
                  this.listDataAll = resData;
                }
                // 总条数和每页条数
                if (this.totals1 < this.size1) {
                  this.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (this.page1 === this.totalPages1) {
                  this.finished1 = true;
                  return false;
                }
              }
            } else {
              this.tabFind = true;
              this.$toast.fail('data无数据！');
            }
          } else {
            this.tabFind = true;
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getTypeNumber() {
      this.$http.medium_marketingMaterialsCountByType({
        networkId: this.siteId,
        size: 20,
        name: this.searchInput,//按名称搜索
        usageType: 'General',
        types: ["VIDEO", "PICTURE", "URL", "PLUGIN"],//素材类型，可传多个类型
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            if (res.data) {
              let num = 0;
              res.data.map((v) => {
                num += v.total;
                this.typeTab.map((i) => {
                  if (v.type === i.type) {
                    i.number = v.total;
                  }
                });
              });
              this.typeTab.map((i) => {
                if (i.type === 'allIcon') {
                  i.number = num
                }
              });
              this.getTypeNumberAuto();
            }
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getTypeNumberAuto() {
      this.$http.medium_marketingMaterialsCountByType({
        networkId: this.siteId,
        size: 20,
        name: this.searchInput,//按名称搜索
        usageType: 'Personal',
        types: ["VIDEO", "PICTURE"],//素材类型，可传多个类型
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            if (res.data) {
              let num = 0;
              res.data.map((v) => {
                num += v.total;
              });
              this.typeTab.map((i) => {
                if (i.type === 'AUTO') {
                  i.number = num;
                }
              });
            }
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getAllInListData() {
      let params = {
        networkId: this.siteId,//网点编号
        page: 0,//页数
        size: 999,//条数
        types: ["VIDEO", "PICTURE", "URL", "PLUGIN"], // 类型
        // usageType:this.typeTabIndex!==2?'General':'Personal',//素材使用类型['Personal-个人','General-通用']
        // name:'',//按名称搜索
        // reviewStatus:'',//素材审核状态[待审核Pending,审核通过Pass,审核未通过Failed]
      }
      this.$http.medium_marketingMaterialsFindByNetwork(params).then((res) => {
        if (res) {
          if (res.code === 200) {
            if (res.data) {
              let resData = res.data.rows;
              if (resData == null || resData.length === 0) {
                this.allListInData = [];
                return false;
              } else {
                resData.map((v) => {
                  v.checked = v.enabled;// enabled:ture已发布，false未发布
                });
                this.allListInData = resData;
                let arrData = [];
                this.allListInData.map((v) => {
                  v.value = '';
                  if (v.enabled) {
                    arrData.push(v);
                  }
                });
                this.playData = arrData;
                // 查询历史屏保配置记录项
                this.getFindSetting();
              }
            }
          }
        }
      });
    },
    // 查询历史屏保配置项
    getFindSetting() {
      this.$http.medium_deviceScreensaverFindAll({
        networkId: this.siteId
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.wordNumber = res.data.screensaverDisplayTime;
            if (res.data.deviceScreensavers) {
              if (res.data.deviceScreensavers.length > 0) {
                let arr = [];
                res.data.deviceScreensavers.map((v,k) => {
                  arr.push({
                    id: v.material.id,
                    createTime: v.material.createTime,
                    updateTime: v.material.updateTime,
                    name: v.material.name,
                    description: v.material.description,
                    usageType: v.material.usageType,
                    contents: v.material.contents,
                    enabled: true,
                    module: v.material.module,
                    indexSort: (k+1),
                    value: v.duration,
                    checked: true,
                    url: v.material.url,
                    type: v.material.type,
                    typical: v.type,
                    reviewRecords: v.reviewRecords
                  });
                });
                this.playData = arr;

                arr.map((v) => {
                  this.listDataAll.map((k) => {
                    // this.allListInData.map((k) => {
                    if (v.id === k.id) {
                      k.value = v.duration;
                    }
                  });
                });
                this.playData.sort((a, b) => a.indexSort - b.indexSort);
                setLocalItem('inPlayListArr', this.playData);
              }
            }
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getOnNumberTime(item) {
      if (!item.value) {
        this.$toast('请设置播放时长！');
        return false;
      }
      if (parseInt(item.value) < 5) {
        this.$toast('播放时长必须超过5秒！');
        return false;
      }
      let arr = this.playData;
      arr.map((v) => {
        if (item.id === v.id) {
          v.enabled = false;
        }
      });
      setLocalItem('inPlayListArr', arr);
      if (this.isRestoring) return;
      this.isRestoring = true;
      // 延时确保在键盘完全收起后执行
      setTimeout(() => {
        window.scrollTo({
          top: this.savedScrollPosition,
          behavior: 'smooth' // 平滑滚动，可选
        });
        this.isRestoring = false;
      }, 300); // 这个时间可以根据需要调整，通常200-400ms
    },
    saveScrollPosition() {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    },
    // 向上移动一位
    getOnMoveUp(item, index) {
      let arr = this.playData;
      arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
      arr.map((v, k) => {
        v.indexSort = (k + 1);
        if (item.id === v.id) {
          v.enabled = false;
        }
      });
      setLocalItem('inPlayListArr', arr);
    },
    // 向下移动一位
    getOnMoveDown(item, index) {
      let arr = this.playData;
      arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
      arr.map((v, k) => {
        v.indexSort = (k + 1);
        if (item.id === v.id) {
          v.enabled = false;
        }
      });
      setLocalItem('inPlayListArr', arr);
    },
    // 删除自定义配置素材中的某一项
    getOnRemovePlay(item, index) {
      this.playData.splice(index, 1);
      this.playData.map((v, k) => {
        v.indexSort = (k + 1);
        if (item.id === v.id) {
          v.enabled = false;
        }
      });
      setLocalItem('inPlayListArr', this.playData);
      this.listDataAll.map((v) => {
        if (v.id === item.id) {
          v.checked = false;
          v.enabled = false;
        }
      });
    },
    // 发布播放设置配置提交操作
    onPublishSettings() {
      if (this.wordNumber === '') {
        this.$toast('请填写显示屏保播放时间时长！');
        return false;
      }
      if (this.wordNumber < 5) {
        this.$toast('闲置时长必须超过5秒！');
        return false;
      }
      // 拦截没有填写时长的数据
      const emptyField = this.playData.find(item => !item.value);
      if (emptyField) {
        this.$toast(`请填写 ${emptyField.name} 播放时长！`);
        return false;
      }
      let arr = [];
      this.playData.map((v) => {
        if (v.typical !== 'System') {
          arr.push({
            materialId: v.id,
            duration: v.value,
            sequenceNumber: v.indexSort
          });
        }
      });

      // 拦截时长小于5的数据
      const emptyFieldArr = this.playData.find(item => parseInt(item.value) < 5);
      if (emptyFieldArr) {
        this.$toast(`${emptyFieldArr.name} 播放时长最小值5秒！`);
        return false;
      }
      this.formItemDisabled = true;
      let pram = {
        networkId: this.siteId,
        screensaverDisplayTime: this.wordNumber,//屏保显示时间
        contents: arr,//屏保内容
      }
      this.$http.medium_deviceScreensaverConfig(pram).then((res) => {
        if (res) {
          this.formItemDisabled = false;
          if (res.code === 200) {
            this.$toast('设置成功！');
            this.playData.map((v) => {
              if (v.checked) {
                v.enabled = v.checked
                // v.stateType = 1;
              }
            });
            delLocalItem('inPlayListArr');
            this.getFindSetting();
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      })
    },
    /*
    * 定时开关机功能
    * 查询操作和提交操作
    * */
    // 时间弹窗选择
    onConfirmValuePicker(value) {
      this.currentTime = value;
      this.timeWeekData.map((v) => {
        if (v.type === this.timeType) {
          if (this.checkType === 's') {
            // 开始时间
            v.startTime = value;
          } else {
            // 结束时间
            v.endTime = value;
          }
        }
      });
      this.showPicker = false;
    },
    // 显示或隐藏时间弹窗
    onTimeValuePicker(val, type) {
      this.timeType = val;
      this.checkType = type;
      this.showPicker = true;
      if (type === 's') {
        this.currentTime = '10:00';
      } else if (type === 'e') {
        this.currentTime = '22:00';
      }
    },
    onButtonSetting(type) {
      let arr = [];
      let prams = {};
      if (type === '关') {
        prams = {
          networkId: this.siteId,
          enabled: this.openCloseChecked,
          details: []
        }
        this.timeWeekData.map((v) => {
          v.checked = false;
          v.startTime = '';
          v.endTime = '';
        });
      } else {
        const emptyField = this.timeWeekData.find(item => item.checked && (item.startTime === '' || item.endTime === ''));
        if (emptyField) {
          this.$toast(`请填写 ${emptyField.title} 开机和关机时间！`);
          return false;
        }
        this.timeWeekData.map((v) => {
          if (v.checked) {
            if (v.startTime && v.endTime) {
              arr.push({
                dayOfWeek: v.name,
                powerOnHour: Number(v.startTime.substring(0, 2)),
                powerOnMinute: Number(v.startTime.substring(3, 5)),
                powerOffHour: Number(v.endTime.substring(0, 2)),
                powerOffMinute: Number(v.endTime.substring(3, 5)),
              });
            }
          }
        });
        prams = {
          networkId: this.siteId,
          enabled: this.openCloseChecked,
          details: arr
        }
      }
      this.formTimeDisabled = true;
      this.$http.medium_powerControlConfig(prams).then((res) => {
        if (res) {
          this.formTimeDisabled = false;
          if (res.code === 200) {
            this.$toast.success(`${this.openCloseChecked ? '开启' : '关闭'} 定时开关机设置成功！`);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getShowTimeData() {
      this.$http.medium_powerControlByNetWork({
        networkId: this.siteId,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.openCloseChecked = res.data.enabled;
            res.data.details.map((v) => {
              this.timeWeekData.map((i) => {
                if (v.dayOfWeek === i.name) {
                  i.checked = true;
                  i.startTime = (v.powerOnHour > 9 ? v.powerOnHour : '0' + v.powerOnHour) + ':' + (v.powerOnMinute > 9 ? v.powerOnMinute : '0' + v.powerOnMinute);
                  i.endTime = (v.powerOffHour > 9 ? v.powerOffHour : '0' + v.powerOffHour) + ':' + (v.powerOffMinute > 9 ? v.powerOffMinute : '0' + v.powerOffMinute);
                }
              });
            });
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      })
    },
    onCheckedClose() {
      // 关闭定时开机
      if (!this.openCloseChecked) {
        this.onButtonSetting('关');
      }
    },
    /*
    * 雷达功能开关
    * 查询操作和提交操作
    * */
    onRadar() {
      if (this.gapValue < 30 || this.gapValue > 300) {
        this.$toast('问候间隔必须在30秒到300秒之间');
        return false;
      }
      if (this.maxDistinct < 1 || this.maxDistinct > 6) {
        this.$toast('最大检测距离必须在1米到6米之间');
        return false;
      }
      this.$http.medium_deviceRadarControlConfig({
        networkId: this.siteId,
        enabled: this.ridChecked,
        gap: this.gapValue ? this.gapValue : 0,
        maxDistinct: this.maxDistinct,
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(`雷达功能设置成功！`);
        } else {
          this.$toast.fail(res.message);
          return false;
        }
      });
    },
    getRadarData() {
      this.$http.medium_deviceRadarControlFindByNetwork({
        networkId: this.siteId,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.ridChecked = res.data.enabled;
            this.gapValue = res.data.gap;
            this.maxDistinct = res.data.maxDistinct;
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    onSubmitAudio() {
      this.$http.device_playbackVolume_config({
        networkId: this.siteId,
        playbackVolume: this.playbackVolume
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success(`音量设置成功！`);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getAudio() {
      this.$http.playbackVolume_findByNetwork({
        networkId: this.siteId,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.playbackVolume = res.data?res.data:0;
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    /*
    * 弹窗提醒播放警示语选择是
    * */
    onDialogBtn(type) {
      medium_audioFileNotifyLib({
        id: this.routerId,
        notify: type === 'yes'
      }).then((res) => {
        if (res) {
          if (res.data) {
            if (res.data.code === 200) {
              this.routerFlag = false;
              if (type === 'yes') {
                this.$toast.success(`播放警示语！`);
              } else {
                this.$toast.success(`取消播放警示语！`);
              }
            } else {
              this.$toast.fail(res.message);
              return false;
            }
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    /*
    * 根据秒数，判断时长，小时，分钟，秒
    * */
    convertSeconds() {
      const hours = Math.floor(this.wordNumber / 3600);
      const minutes = Math.floor((this.wordNumber % 3600) / 60);
      const seconds = this.wordNumber % 60;
      if (hours > 0) {
        this.formattedTime = hours + '小时 ' + minutes + '分钟 ' + seconds + '秒';
        // this.formattedTime =
        //     String(hours).padStart(2, '0') + '小时' +
        //     String(minutes).padStart(2, '0') + '分钟' +
        //     String(seconds).padStart(2, '0')+'秒';
      } else if (minutes > 0) {
        this.formattedTime = minutes + '分钟 ' + seconds + '秒';
        // this.formattedTime =
        //     String(minutes).padStart(2, '0') + '分钟' +
        //     String(seconds).padStart(2, '0')+'秒';
      } else if (seconds > 0) {
        this.formattedTime = seconds + '秒';
        // this.formattedTime =
        //     String(seconds).padStart(2, '0')+'秒';
      }
    },
    // 自定义素材类型 Custom Material Types
    // 上传素材表单内的自定义素材类型列表选项
    onCustomMaterialType(value) {
      this.showCustomValueParams = value;
      this.showCustomTypeFlag = false;
    },
    // 审核类型 Review Type
    onReviewType(value) {
      this.showReviewValueParams = value;
      this.showReviewFlag = false;
    },
    // 官方素材
    onMaterialOfficialType(value) {
      this.showMaterialOfficialValueParams = value;
      this.showMaterialOfficialFlag = false;
    },
    //素材类型 Material Type
    onMaterialType(value) {
      this.showMaterialValueParams = value;
      this.showMaterialFlag = false;
    },
    getCancel(){
      if(this.subDisabled){
        this.$toast('资料上传中！');
        return false;
      }
      this.customizeMaterialsFlag=false;
      this.subDisabled=false;
    },
    // 提交或修改素材资料
    onAddFigure() {
      if (!this.showCustomValueParams.type) {
        this.$toast('请选择素材类型！');
        return false;
      }
      if (!this.editCustomizeParams.name) {
        this.$toast('请填写素材标题！');
        return false;
      }
      if (!this.editCustomizeParams.description) {
        this.$toast('请填写素材描述！');
        return false;
      }
      if (!this.editCustomizeParams.id) {
        // 新增
        if (!this.fileObject) {
          this.$toast('请上传素材！');
          return false;
        }
        if (!this.fileObject.name) {
          this.$toast('请上传素材！');
          return false;
        }
      } else {
        // 修改
        if (!this.fileObject) {
          this.$toast('请重新上传素材！');
          return false;
        }
        if (!this.fileObject.name) {
          this.$toast('请重新上传素材！');
          return false;
        }
      }
      if (!this.fileObject.name) {
        this.$toast('请上传素材！');
        return false;
      }
      // 兼容安卓和ios微信浏览器
      this.uploadVideo();
      // return false;
      // this.subDisabled = true;
      // // // 创建 FormData 对象
      // // const formData = new FormData();
      // // formData.append('networkId', this.siteId);
      // // formData.append('type', this.showCustomValueParams.type);
      // // formData.append('name', this.editCustomizeParams.name);
      // // formData.append('description', this.editCustomizeParams.description);
      // // formData.append('contents[0].file', this.fileObject); // 文件对象
      // // formData.append('contents[0].fileName', this.fileObject.name); // 文件对象
      // // formData.append('contents[0].fileSize', this.fileObject.size); // 文件对象
      // // formData.append('contents[0].width', this.width); // 文件对象
      // // formData.append('contents[0].height', this.height); // 文件对象
      //
      // if (!this.editCustomizeParams.id) {
      //   // axios.post('/api/xzxzs/api/marketingMaterials/addPersonalMaterials', formData, {
      //   //   headers: {
      //   //     'Content-Type': 'multipart/form-data'
      //   //   }
      //   // }).then(response => {
      //   //   if (response.data) {
      //   //     if (response.data.code === 200) {
      //   //       this.subDisabled = false;
      //   //       this.customizeMaterialsFlag = false;
      //   //       this.$toast.success('提交成功！');
      //   //       // 查询素材列表数据
      //   //       this.getListData();
      //   //       // 素材类型的数量
      //   //       this.getTypeNumber();
      //   //     } else {
      //   //       this.$toast.fail(response.data.message);
      //   //       return false;
      //   //     }
      //   //   }
      //   // }).catch(error => {
      //   //   console.error('error',error);
      //   //   if (error.response) {
      //   //     // 请求已发出，服务器以状态码回应，但没有成功（例如404、500）
      //   //     console.error('Error data:', error.response.data);
      //   //     console.error('Error status:', error.response.status);
      //   //     this.$toast(error.message);
      //   //   } else if (error.request) {
      //   //     // 请求已发出，但没有收到回应（例如网络断开）
      //   //     console.error('No response:', error.request);
      //   //     this.$toast(error.message);
      //   //   } else {
      //   //     // 在设置请求时发生了某些事情触发了错误
      //   //     console.error('Error message:', error.message);
      //   //     this.$toast(error.message)
      //   //   }
      //   // });
      //   // 增加素材
      //   let params = {
      //     "networkId":this.siteId,
      //     "type":this.showCustomValueParams.type,//(AI,VIDEO,AUDIO,PICTURE,URL,PLUGIN)
      //     "name":this.editCustomizeParams.name,
      //     "description":this.editCustomizeParams.description,
      //     "contents[0].file":this.fileObject,
      //     "contents[0].fileName":this.fileObject.name,
      //     "contents[0].fileSize":this.fileObject.size,
      //     "contents[0].width":this.width,
      //     "contents[0].height":this.height,
      //   }
      //   this.$http.marketingMaterials_addPersonalMaterials(params).then((res)=>{
      //     if(res){
      //       if(res.code===200){
      //         this.subDisabled = false;
      //         this.customizeMaterialsFlag = false;
      //         this.$toast.success('提交成功！');
      //         // 查询素材列表数据
      //         this.getListData();
      //         // 素材类型的数量
      //         this.getTypeNumber();
      //       }else{
      //         this.$toast.fail(res.message);
      //         return false;
      //       }
      //     }
      //   });
      // } else {
      //   // formData.append('id', this.editCustomizeParams.id);
      //   // axios.post('/api/xzxzs/api/marketingMaterials/updatePersonalMaterials', formData, {
      //   //   headers: {
      //   //     'Content-Type': 'multipart/form-data'
      //   //   }
      //   // }).then(response => {
      //   //   if (response.data) {
      //   //     if (response.data.code === 200) {
      //   //       this.customizeMaterialsFlag = false;
      //   //       this.$toast.success('提交成功！');
      //   //       this.getListData();
      //   //     } else {
      //   //       this.$toast.fail(response.data.message);
      //   //       return false;
      //   //     }
      //   //   }
      //   // }).catch(error => {
      //   //   console.error('error',error);
      //   //   if (error.response) {
      //   //     // 请求已发出，服务器以状态码回应，但没有成功（例如404、500）
      //   //     console.error('Error data:', error.response.data);
      //   //     console.error('Error status:', error.response.status);
      //   //     this.$toast(error.message);
      //   //   } else if (error.request) {
      //   //     // 请求已发出，但没有收到回应（例如网络断开）
      //   //     console.error('No response:', error.request);
      //   //     this.$toast(error.message);
      //   //   } else {
      //   //     // 在设置请求时发生了某些事情触发了错误
      //   //     console.error('Error message:', error.message);
      //   //     this.$toast(error.message)
      //   //   }
      //   // });
      //   // 修改素材
      //   let params = {
      //     "id":this.editCustomizeParams.id,
      //     "networkId":this.siteId,
      //     "type":this.showCustomValueParams.type,//(AI,VIDEO,AUDIO,PICTURE,URL,PLUGIN)
      //     "name":this.editCustomizeParams.name,
      //     "description":this.editCustomizeParams.description,
      //     "contents[0].file":this.fileObject,
      //     "contents[0].fileName":this.fileObject.name,
      //     "contents[0].fileSize":this.fileObject.size,
      //     "contents[0].width":this.width,
      //     "contents[0].height":this.height,
      //   }
      //   this.$http.marketingMaterials_updatePersonalMaterials(params).then((res)=>{
      //     if(res){
      //       if(res.code===200){
      //         this.subDisabled = false;
      //         this.customizeMaterialsFlag = false;
      //         this.$toast.success('提交成功！');
      //         // 查询素材列表数据
      //         this.getListData();
      //         // 素材类型的数量
      //         this.getTypeNumber();
      //       }else{
      //         this.$toast.fail(res.message);
      //         return false;
      //       }
      //     }
      //   });
      // }
    },
    // 编辑素材
    onEditFigureItem(item) {
      this.fileVideoShowUrl = null;
      this.fileObject = null;
      this.fileList = [{url: item.contents[0].filePath}];
      this.customizeMaterialsFlag = true;
      this.editCustomizeParams = item;
      this.listCustomTypeData.map((v) => {
        if (v.type === item.type) {
          this.showCustomValueParams = v;
        }
      });
    },
    // 删除素材
    onDeleteFigure(item) {
      Dialog.confirm({
        title: '',
        message: `确定删除"${item.name}"吗？`,
      }).then(() => {
        // on confirm
        this.$http.marketingMaterials_deletePersonalMaterials({id: item.id}).then((res) => {
          if (res) {
            if (res.code === 200) {
              let indexKey = null;
              this.playData.map((v, k) => {
                if (v.id === item.id) {
                  indexKey = k;
                }
              });
              this.playData.splice(indexKey, 1);
              this.playData.map((v, k) => {
                v.indexSort = (k + 1);
                if (item.id === v.id) {
                  v.enabled = false;
                }
              });
              setLocalItem('inPlayListArr', this.playData);
              this.listDataAll.map((v) => {
                if (v.id === item.id) {
                  v.checked = false;
                  v.enabled = false;
                }
              });
              this.$toast.success('删除成功！');
              this.getListData();
              // 素材类型的数量
              this.getTypeNumber();
            } else {
              this.$toast.fail(res.message);
              return false;
            }
          }
        });
      }).catch(() => {
        // on cancel
        console.log('cancel')
      });
    },
    getShowMeta() {
      this.customizeMaterialsFlag = true;
      this.editCustomizeParams = {};
      this.showCustomValueParams = {};
      this.fileList = [];
      this.fileVideoShowUrl = null;
      this.fileObject = null;
    },
    beforeRead1(e) {
      // 检查图片大小
      const isLt5M = e.size / 1024 / 1024 < 5;
      console.log(e.size, isLt5M, e.size / 1024 / 1024 + 'MB')
      if (!isLt5M) {
        this.$message.error('图片大小不能超过5MB!');
        return false;
      }
      if (e.type.split('/')[0] !== 'image') {
        this.$toast('请上传图片格式！');
        return false;
      }
      return true;
    },
    beforeRead(e) {
      if (!this.showCustomValueParams.type) {
        this.$toast('请您选择素材类型！');
        return false;
      }
      if (this.showCustomValueParams.type === 'PICTURE') {
        // 检查图片大小
        const isLt5M = e.size / 1024 / 1024 < 5;
        console.log(e.size, isLt5M, e.size / 1024 / 1024 + 'MB')
        if (!isLt5M) {
          this.$toast('图片大小不能超过5MB!');
          return false;
        }
        if (e.type.split('/')[0] !== 'image') {
          this.$toast('请您选择图片类型！');
          return false;
        }
      } else if (this.showCustomValueParams.type === 'VIDEO') {
        // 检查视频大小
        const isLt5M = e.size / 1024 / 1024 < 500;
        console.log(e.size, isLt5M, e.size / 1024 / 1024 + 'MB')
        if (!isLt5M) {
          this.$toast('视频大小不能超过500MB!');
          return false;
        }
        if (e.type.split('/')[0] !== 'video') {
          this.$toast('请您选择视频类型！');
          return false;
        }
      }
      return true;
    },
    getReadDelete1(e) {
      this.fileListQr = [];
    },
    getReadDelete(e) {
      if (this.fileVideoShowUrl) {
        this.fileVideoShowUrl = null;
      }
      this.fileObject = {};
      this.fileList = [];
      this.subDisabled = false;
    },
    // 文件选择变化
    onFileChange(e) {
      this.afterRead(e);
    },
    afterRead(e) {
      if (!this.showCustomValueParams.type) {
        this.$toast('请您选择素材类型！');
        return false;
      }
      if (this.showCustomValueParams.type === 'PICTURE') {
        if (e.file.type.split('/')[0] !== 'image') {
          this.$toast('请您选择图片类型！');
          return false;
        }
      } else if (this.showCustomValueParams.type === 'VIDEO') {
        if(this.isAndroid){
          // 安卓机器访问进入
          const files = e.target.files[0];
          // if (files.type.indexOf('mp4') !== -1) {
          // } else {
          //   this.$toast('请您选择MP4的视频格式！');
          //   return false;
          // }
          if (files.type.split('/')[0] !== 'video') {
            this.$toast('请您选择视频类型！');
            return false;
          }
        }else{
          // if (e.file.type.indexOf('mp4') !== -1) {
          // } else {
          //   this.$toast('请您选择MP4的视频格式！');
          //   return false;
          // }
          if (e.file.type.split('/')[0] !== 'video') {
            this.$toast('请您选择视频类型！');
            return false;
          }
        }
      }
      if (this.fileList.length > 1) {
        this.fileList = [this.fileList[this.fileList.length - 1]];
      }
      if (this.showCustomValueParams.type === 'VIDEO') {
        let that = this;
        // 视频
        if(this.isAndroid){
          const file = e.target.files[0];
          this.fileObject = file;
          that.fileVideoShowUrl = URL.createObjectURL(file);
          that.fileList = [file]
        }else{
          this.fileObject = e.file;
          const file = e.file;
          that.fileVideoShowUrl = URL.createObjectURL(file);
        }

        // 创建video元素
        const video = document.createElement('video');
        video.src = that.fileVideoShowUrl;
        video.addEventListener('loadedmetadata', () => {
          console.log(video.videoWidth,video.videoHeight)
          // 获取视频的宽高
          that.width = video.videoWidth;
          that.height = video.videoHeight;
        });
      } else if (this.showCustomValueParams.type === 'PICTURE') {
        this.fileObject = e.file;
        const file = e.file;
        // 图片
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            this.width = img.width;
            this.height = img.height;
          };
          img.src = e.target.result; // 设置img的src为读取的文件内容URL
        };
        reader.readAsDataURL(file);
      }
    },
    afterRead1(e) {
      this.qrCode = e.file;
    },
    // 上传视频文件
    async uploadVideo() {
      if(!this.fileObject.name){
        this.$toast('请上传素材！');
        return false;
      }
      this.subDisabled = true;
      this.isUploading = true;
      this.uploadProgress = 0;

      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append('networkId', this.siteId);
        formData.append('type', this.showCustomValueParams.type);
        formData.append('name', this.editCustomizeParams.name);
        formData.append('description', this.editCustomizeParams.description);
        formData.append('contents[0].file', this.fileObject); // 文件对象
        formData.append('contents[0].fileName', this.fileObject.name); // 文件对象
        formData.append('contents[0].fileSize', this.fileObject.size); // 文件对象
        formData.append('contents[0].width', this.width); // 文件对象
        formData.append('contents[0].height', this.height); // 文件对象

        // 安卓设备特殊处理
        if (this.isAndroid) {
          // 新增
          if (!this.editCustomizeParams.id) {
            await this.uploadForAndroid(formData);
          }else{
            // 修改
            formData.append('id', this.editCustomizeParams.id);
            await this.uploadForAndroidUpdate(formData);
          }
        } else {
          // 新增
          if (!this.editCustomizeParams.id) {
            await this.uploadStandard(formData);
          }else{
            // 修改
            formData.append('id', this.editCustomizeParams.id);
            await this.uploadStandardUpdate(formData);
          }
        }
        this.isUploading = false;
        this.subDisabled = false;
      } catch (error) {
        this.isUploading = false;
        this.subDisabled = false;
        this.handleUploadError(error);
      }
    },

    // 处理上传错误
    handleUploadError(error) {
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        this.$toast('上传超时，请检查网络连接后重试');
        return false;
      } else if (error.message.includes('Network Error')) {
        this.$toast('网络错误，请检查网络连接');
        return false;
      } else if (error.response) {
        this.$toast(`服务器错误: ${error.response.status}`);
        return false;
      } else {
        this.$toast(`上传失败: ${error.message}`);
        return false;
      }
    },
    // 新增上传资料，ios
    // 标准上传方法
    uploadStandard(formData) {
      return new Promise((resolve, reject) => {
        axios.post('api/xzxzs/api/marketingMaterials/addPersonalMaterials', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 120000, // 2分钟超时
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.uploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        }).then(response => {
          // 成功响应
          if (response.data) {
            if (response.data.code === 200) {
              this.subDisabled = false;
              this.customizeMaterialsFlag = false;
              this.$toast.success('提交成功！');
              // 查询素材列表数据
              this.getListData();
              // 素材类型的数量
              this.getTypeNumber();
            } else {
              this.$toast.fail(response.data.message);
              return false;
            }
          }
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改上传资料 ios
    uploadStandardUpdate(formData) {
      return new Promise((resolve, reject) => {
        axios.post('api/xzxzs/api/marketingMaterials/updatePersonalMaterials', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 120000, // 2分钟超时
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.uploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        }).then(response => {
          // 成功响应
          if (response.data) {
            if (response.data.code === 200) {
              this.subDisabled = false;
              this.customizeMaterialsFlag = false;
              this.$toast.success('提交成功！');
              // 查询素材列表数据
              this.getListData();
              // 素材类型的数量
              this.getTypeNumber();
            } else {
              this.$toast.fail(response.data.message);
              return false;
            }
          }
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 新增上传资料
    // 安卓设备专用上传方法
    uploadForAndroid(formData) {
      return new Promise((resolve, reject) => {
        // 使用更简单的配置，避免安卓兼容性问题
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
          }
        });

        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            // 成功响应
            let response = JSON.parse(xhr.response)
            if (response) {
              if (response.code === 200) {
                this.subDisabled = false;
                this.customizeMaterialsFlag = false;
                this.$toast.success('提交成功！');
                // 查询素材列表数据
                this.getListData();
                // 素材类型的数量
                this.getTypeNumber();
              } else {
                this.$toast.fail(response.message);
                return false;
              }
            }
            resolve({ data: 'success' });
          } else {
            reject(new Error(`上传失败: ${xhr.status}`));
          }
        });

        xhr.addEventListener('error', () => {
          reject(new Error('网络错误，请检查网络连接'));
        });

        xhr.addEventListener('timeout', () => {
          reject(new Error('上传超时，请重试'));
        });

        xhr.timeout = 120000; // 2分钟超时
        xhr.open('POST', 'api/xzxzs/api/marketingMaterials/addPersonalMaterials');
        xhr.send(formData);
      });
    },
    // 修改上传资料
    uploadForAndroidUpdate(formData) {
      return new Promise((resolve, reject) => {
        // 使用更简单的配置，避免安卓兼容性问题
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
          }
        });

        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            // 成功响应
            let response = JSON.parse(xhr.response)
            if (response) {
              if (response.code === 200) {
                this.subDisabled = false;
                this.customizeMaterialsFlag = false;
                this.$toast.success('提交成功！');
                // 查询素材列表数据
                this.getListData();
                // 素材类型的数量
                this.getTypeNumber();
              } else {
                this.$toast.fail(response.message);
                return false;
              }
            }
            resolve({ data: 'success' });
          } else {
            reject(new Error(`上传失败: ${xhr.status}`));
          }
        });

        xhr.addEventListener('error', () => {
          reject(new Error('网络错误，请检查网络连接'));
        });

        xhr.addEventListener('timeout', () => {
          reject(new Error('上传超时，请重试'));
        });

        xhr.timeout = 120000; // 2分钟超时
        xhr.open('POST', 'api/xzxzs/api/marketingMaterials/updatePersonalMaterials');
        xhr.send(formData);
      });
    },
    // 检测设备类型
    detectDevice() {
      const ua = navigator.userAgent.toLowerCase();
      this.isAndroid = ua.indexOf('android') > -1;
      if (this.isAndroid) {
        // console.log('安卓设备');
      } else if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        // console.log('iOS设备');
      } else {
        // console.log('其他设备');
      }
    },
    onReloadSubmit() {
      this.$http.network_updateQrCodeToDevice({
        networkId: this.siteId,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success('更新成功！');
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    onQrCodeSubmit() {
      if (!this.qrCode) {
        this.$toast('请上传文件');
        return false;
      }
      this.$http.network_addQrCode({
        file: this.qrCode,
        networkId: this.siteId,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success('添加成功！');
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
  },
  created() {
    this.detectDevice();
    // 网点编号
    if (this.$route.query.sid) {
      this.siteId = this.$route.query.sid;
      let localSiteId = getLocalItem('siteIdLocal');
      if (localSiteId) {
        if (this.siteId !== localSiteId) {
          setLocalItem('siteIdLocal', this.siteId);
          delLocalItem('inPlayListArr');
        }
      } else {
        setLocalItem('siteIdLocal', this.siteId);
        delLocalItem('inPlayListArr');
      }
      // 素材类型的数量
      this.getTypeNumber();
      // 一页999条所有素材数据
      // this.getAllInListData();
      // 查询历史屏保配置记录项
      this.getFindSetting();
    } else {
      this.$toast('无网点编号！');
    }
    // http://192.168.8.191:8083/medium?sid=54010888&type=1&title=%E5%8F%91%E7%8E%B0%E9%9D%9E%E7%90%86%E6%80%A7%E8%B4%AD%E5%BD%A9
    // 如果路径有参数type和title则提示弹窗提醒
    if (this.$route.query.type === '1') {
      if (this.$route.query.title) {
        this.routerFlag = true;
        this.routerId = this.$route.query.id;
        this.routerTitle = this.$route.query.title;
      }
    }
  }
}
</script>
<template>
  <div class="wrap">
    <!--      下语音小助手提醒通知弹窗提示-->
    <van-popup v-model="routerFlag" round position="center" :style="{ minHeight: '26%',width:'80%' }">
      <div class="inner-diag">
        <div class="inner-title">{{ routerTitle }}</div>
        <div class="inner-txt">是否播放警示语？</div>
        <div class="inner-btn">
          <van-button type="primary" class="block-btn font" color="#f5f6fa" @click="onDialogBtn('no')">否</van-button>
          <van-button type="primary" class="block-btn" color="#e62d2d" @click="onDialogBtn('yes')">是</van-button>
        </div>
      </div>
    </van-popup>
    <!--时间选择-->
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
          v-model="currentTime"
          type="time"
          title="选择时间"
          :min-hour="0"
          :max-hour="23"
          @confirm="onConfirmValuePicker"
          @cancel="showPicker = false"
      />
    </van-popup>
    <!-- 查询自定义-  审核类型 -->
    <van-popup v-model="showReviewFlag" position="bottom">
      <van-picker
          show-toolbar
          title="审核类型"
          :columns="AdmitNameList"
          value-key="name"
          :default-index="0"
          @confirm="onReviewType"
          @cancel="showReviewFlag = false"
      />
    </van-popup>
    <!-- 查询自定义-  素材类型 -->
    <van-popup v-model="showMaterialFlag" position="bottom">
      <van-picker
          show-toolbar
          title="素材类型"
          :columns="SingleNameList"
          value-key="name"
          @confirm="onMaterialType"
          @cancel="showMaterialFlag = false"
      />
    </van-popup>
    <!-- 查询官方-  素材类型 -->
    <van-popup v-model="showMaterialOfficialFlag" position="bottom">
      <van-picker
          show-toolbar
          title="素材类型"
          :columns="OfficialSingleNameList"
          value-key="name"
          @confirm="onMaterialOfficialType"
          @cancel="showMaterialOfficialFlag = false"
      />
    </van-popup>
    <!--    自定义素材上传弹窗-->
    <van-popup v-model="customizeMaterialsFlag" round position="center" :close-on-click-overlay="false" :style="{width:'80%' }">
      <div class="inner-diag">
        <div class="fixed-close" @click="getCancel">&times;</div>
        <div class="section-title">{{ editCustomizeParams.id ? '编辑素材' : '上传自定义素材' }}</div>
        <div class="upload-requirements">
          <div class="req-title">📋 上传要求：</div>
          <div class="req-content">
            <div>✓ 仅支持竖屏素材（9:16比例）</div>
            <div>✓ 视频：≤500MB，≤3分钟</div>
            <div>✓ 图片：JPG/PNG格式，≤5MB</div>
            <div>✓ 上传后需等待审核，审核通过后可使用</div>
          </div>
        </div>
        <div class="form-label">素材类型 <span style="color: #e62d2d;">*</span></div>
        <div class="form-commit">
          <van-field
              v-model="showCustomValueParams.name"
              name=""
              label=""
              readonly="readonly"
              placeholder="请选择素材类型"
              @click="showCustomTypeFlag=true"
          >
            <template #right-icon>
              <van-icon name="arrow-down"/>
            </template>
          </van-field>
        </div>
        <div class="form-label">素材标题 <span style="color: #e62d2d;">*</span></div>
        <div class="form-commit">
          <van-field
              v-model="editCustomizeParams.name"
              name="name"
              label=""
              type="text"
              autocomplete="off"
              placeholder="请输入素材标题（如：春节宣传视频）"
          />
        </div>
        <div class="form-label">素材描述 <span style="color: #e62d2d;">*</span></div>
        <div class="form-commit">
          <van-field
              v-model="editCustomizeParams.description"
              name="name"
              label=""
              type="textarea"
              autocomplete="off"
              placeholder="请输入素材描述（如：用于春节期间的宣传展示）"
          />
        </div>
        <div class="form-label">选择文件 <span style="color: #e62d2d;">*</span></div>
        <div class="group-video">
          <div class="group-video-load">
            <div class="post-video" v-if="fileList&&fileList[0]&&fileList[0].url&&(fileList[0].url.indexOf('.mp4')!==-1||fileList[0].url.indexOf('.mov')!==-1)">
              <video :src="fileList[0].url"></video>
            </div>
            <div class="post-video" v-if="fileVideoShowUrl&&fileList">
              <video ref="videoPreview" :src="fileVideoShowUrl"></video>
            </div>
            <!--            安卓手机，视频文件上传-->
            <div class="upload-area" v-if="isAndroid&&showCustomValueParams.type==='VIDEO'&&fileList.length===0">
              <div class="icon-calm"><van-icon name="photograph" /></div>
              <input type="file"
                     class="file-input"
                     ref="fileInput"
                     accept="video/*"
                     @change="onFileChange"/>
            </div>
            <van-uploader v-model="fileList" v-else :max-count="1" accept="image,video" :before-delete="getReadDelete"
                          :after-read="afterRead" :before-read="beforeRead"/>
          </div>
        </div>
        <div class="">
          <div class="progress-container" :class="{ 'active': isUploading }">
            <div class="progress-info">
              <span>上传进度</span>
              <span>{{ uploadProgress }}%</span>
            </div>
            <div class="progress-bar">
              <div class="progress-fill" :style="{ width: uploadProgress + '%' }"></div>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" @click="getCancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" :disabled="subDisabled" @click="onAddFigure">上传
          </van-button>
        </div>
      </div>
    </van-popup>
    <!--   自定义素材类型 -->
    <van-popup v-model="showCustomTypeFlag" position="bottom">
      <van-picker
          show-toolbar
          title="自定义素材类型"
          :columns="listCustomTypeData"
          :default-index="0"
          value-key="name"
          @confirm="onCustomMaterialType"
          @cancel="showCustomTypeFlag = false"
      />
    </van-popup>
    <!--  主体内容布局开始  -->
    <div class="tabs">
      <van-tabs v-model="activeTab" @change="onHeadTab" animated swipeable sticky>
        <van-tab title="屏保配置" name="0"></van-tab>
        <van-tab title="播放配置" name="1"></van-tab>
        <van-tab title="功能开关" name="2"></van-tab>
      </van-tabs>
    </div>
    <div class="tab-content">
      <div v-if="activeTab==='0'" class="content-box">
        <div class="tabs-style">
          <van-tabs v-model="typeTabIndex" :before-change="onTabCurrent">
            <van-tab v-for="(item,index) in typeTab" :key="index" :title="' '+index">
              <template #title v-if="item.name">
                <div v-if="item.name"><span class="icon-style">{{ item.icon }}</span>{{ item.name }} <span
                    class="num-style">{{ item.number }}</span></div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
        <div class="choice-box">
          <div class="card">
            <div class="card-title">
              {{ typeTab[typeTabIndex].text }}
              <span class="btn-span" v-if="typeTabIndex===1" @click="getShowMeta"><van-icon name="plus"/>上传素材</span>
            </div>
            <div class="list-data" v-if="typeTabIndex!==1">
              <!-- 搜索框 -->
              <!--  筛选-->
              <div class="filter-section" v-if="typeTabIndex===0">
                <div class="filter-row">
                  <div class="filter-group">
                    <label class="filter-label">搜索</label>
                    <van-field class="search-text" type="text" v-model="searchInput"
                               placeholder="🔍 搜索素材名称..."></van-field>
                  </div>
                  <div class="filter-group">
                    <label class="filter-label">素材类型</label>
                    <van-field
                        v-model="showMaterialOfficialValueParams.name"
                        name=""
                        label=""
                        readonly="readonly"
                        placeholder="请选择素材类型"
                        @click="showMaterialOfficialFlag=true"
                    >
                      <template #right-icon>
                        <van-icon name="arrow-down"/>
                      </template>
                    </van-field>
                  </div>
                </div>
              </div>
              <!--素材列表-->
              <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt"
                        :immediate-check="false" @load="onLoad">
                <div class="material-list" v-if="listDataAll.length>0">
                  <div class="material-item" :class="item.enabled?'new-item':'new-item'"
                       v-for="(item,index) in listDataAll" :key="index">
                    <div class="material-icon">{{ icons[item.type] }}</div>
                    <div class="material-info">
                      <div class="material-name">{{ item.name }}</div>
                      <div class="material-meta">{{ iconsName[item.type] }}</div>
                    </div>
                    <div class="material-switch">
                      <div class="switch">
                        <van-switch v-model="item.checked" :disabled="item.typical==='System'" size="24px"
                                    @change="() => getOnSwitch(index,item)" active-color="#ee0a24"
                                    inactive-color="#dcdee0"/>
                      </div>
                      <span class="material-switch-label">{{ !item.checked ? '启用' : '停用' }}</span>
                    </div>
                  </div>
                </div>
                <!--暂无素材-->
                <div class="empty-state" v-else>
                  <div class="empty-icon">{{ icons[typeTab[typeTabIndex].type] }}</div>
                  <div class="empty-text">暂无数据</div>
                </div>
              </van-list>
            </div>
            <div class="list-data" v-else>
              <div class="filter-section">
                <div class="filter-row">
                  <div class="filter-group">
                    <label class="filter-label">审核状态</label>
                    <van-field
                        v-model="showReviewValueParams.name"
                        name=""
                        label=""
                        readonly="readonly"
                        placeholder="请选择审核状态"
                        @click="showReviewFlag=true"
                    >
                      <template #right-icon>
                        <van-icon name="arrow-down"/>
                      </template>
                    </van-field>
                  </div>
                  <div class="filter-group">
                    <label class="filter-label">素材类型</label>
                    <van-field
                        v-model="showMaterialValueParams.name"
                        name=""
                        label=""
                        readonly="readonly"
                        placeholder="请选择素材类型"
                        @click="showMaterialFlag=true"
                    >
                      <template #right-icon>
                        <van-icon name="arrow-down"/>
                      </template>
                    </van-field>
                  </div>
                </div>
                <!--                        <button class="filter-reset" onclick="resetFilters()">重置筛选</button>-->
              </div>
              <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt"
                        :immediate-check="false" @load="onLoad">
                <div class="material-list-auto" v-if="listDataAll.length>0">
                  <div class="material-item-auto"
                       :class="[item.reviewStatus,item.enabled?'new-item-auto':'new-item-auto']"
                       v-for="(item,index) in listDataAll" :key="index">
                    <div class="material-icon-auto">{{ icons[item.type] }}</div>
                    <div class="material-info-auto">
                      <div class="material-name-auto">{{ item.name }}</div>
                      <div class="material-meta">{{ item.description }}</div>
                      <div class="material-meta">{{ iconsName[item.type] }} ·
                        {{ item.contents[0] && item.contents[0].fileSize|formatBytes }}
                      </div>
                      <div class="material-meta">{{ item.createTime|timestampToTime }}</div>
                    </div>
                    <div class="material-icon-evolve">
                      <div class="status-evolve pass"
                           v-if="item.reviewRecords&&item.reviewRecords[0]&&item.reviewRecords[0].status==='Pass'"></div>
                      <div class="status-evolve pending-icon"
                           v-else-if="item.reviewRecords&&item.reviewRecords[0]&&item.reviewRecords[0].status==='Pending'">
                        ⏳ 待审核
                      </div>
                      <div class="status-evolve failed-icon"
                           v-else-if="item.reviewRecords&&item.reviewRecords[0]&&item.reviewRecords[0].status==='Failed'">
                        ❌ 已驳回
                      </div>
                      <div class="m-a-t">
                        <div class="material-switch-auto"
                             v-if="item.reviewRecords&&item.reviewRecords[0]&&item.reviewRecords[0].status==='Pass'">
                          <div class="switch">
                            <van-switch v-model="item.checked" size="24px" @change="() => getOnSwitch(index,item)"
                                        active-color="#ee0a24" inactive-color="#dcdee0"/>
                          </div>
                          <span class="material-switch-label">{{ !item.checked ? '启用' : '停用' }}</span>
                        </div>
                        <div>
                          <span class="edit-evolve"
                                v-if="item.reviewRecords&&item.reviewRecords[0]&&item.reviewRecords[0].status!=='Pass'"
                                @click="onEditFigureItem(item)">✎</span>
                          <span class="del-evolve" @click="onDeleteFigure(item)">🗑️</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!--暂无素材-->
                <div class="empty-state" v-else>
                  <div class="empty-icon">{{ icons[typeTab[typeTabIndex].type] }}</div>
                  <div class="empty-text">暂无数据</div>
                </div>
              </van-list>
            </div>
          </div>
        </div>
        <div class="info-text" style="margin-top: 0;">
          ℹ️ <span>提示:</span>启用素材后会自动加入播放列表。在播放配置中可管理播放顺序和时长。
        </div>
      </div>
      <div v-if="activeTab==='1'">
        <!-- 闲时启动屏保设置 -->
        <div class="card">
          <div class="carousel-set">
            <div class="switch-item" style="padding: 8px 0; border: none;">
              <div>
                <div class="switch-label">闲时启动屏保</div>
                <div class="switch-desc">*小助手将在闲时进入屏幕保护内容轮播状态</div>
              </div>
              <!--              <div>-->
              <!--                <van-button  block plain color="#ee0a24" type="default" @click="">刷新</van-button>-->
              <!--              </div>-->
              <!--                  <div class="switch">-->
              <!--                    <van-switch v-model="checked" size="24px"  active-color="#ee0a24" inactive-color="#dcdee0" />-->
              <!--                  </div>-->
            </div>
          </div>
          <div class="carousel-settings">
            <div class="input-group">
              <span>闲置时长:</span>
              <van-field type="number" :min="5" :error-message="wordNumber < 5? '闲置时长必须超过5秒' : ''"
                         v-model="wordNumber" @blur="convertSeconds"></van-field>
              <span>秒</span>
            </div>
            <!--                <van-button type="primary" size="normal" color="rgb(238, 10, 36)">确认启动屏保</van-button>-->
          </div>
          <!--              <div>{{formattedTime}}</div>-->
        </div>
        <!-- 播放列表 -->
        <div class="playlist-card">
          <div class="playlist-header">
            <div class="playlist-title">
              🎵 当前播放列表
              <span class="playlist-count">{{ playData.length }}</span>
            </div>
          </div>
          <div class="playlist-item" :class="item.enabled?'check-item':'new-item'" v-for="(item,index) in playData"
               :key="index">
            <div class="order-number" :class="item.enabled?'colR':'colG'">{{ index + 1 }}</div>
            <div class="material-icon">{{ icons[item.type] }}</div>
            <div class="material-info">
              <div class="material-name">{{ item.name }} <span
                  :class="item.usageType==='General'?'gGeneral':'pPersonal'">{{ item.usageType === 'General' ? '官方' : '自定义' }}</span>
              </div>
              <div class="duration-edit">
                <span>时长:</span>
                <van-field class="time-text" type="number" :readonly="item.typical==='System'" v-model="item.value"
                           :min="5" :error-message="parseInt(item.value) < 5? '少于5秒' : ''"
                           @focus="saveScrollPosition" @change="getOnNumberTime(item)"></van-field>
                <span>秒</span>
              </div>
            </div>
            <div class="playlist-controls" v-if="item.typical!=='System'">
              <span class="order-btn order-btn-disabled" v-if="index===type1Count">▲</span>
              <span class="order-btn" v-else @click="getOnMoveUp(item,index)">▲</span>
              <span class="order-btn" v-if="playData.length>(index+1)" @click="getOnMoveDown(item,index)">▼</span>
              <span class="order-btn order-btn-disabled" v-else>▼</span>
            </div>
            <span class="remove-btn" v-if="item.typical!=='System'" @click="getOnRemovePlay(item,index)"
                  title="移除">✕</span>
          </div>
          <div class="material-list" v-show="playData.length===0">
            <div class="empty-state">
              <div class="empty-icon">📋</div>
              <div class="empty-text">启用素材后将自动加入播放列表</div>
            </div>
          </div>
        </div>
        <div class="info-text" style="margin-top: 0;">
          ℹ️ <span>提示:</span>可通过▲▼箭头调整播放顺序,直接修改时长输入框调整播放时长。
        </div>
        <div class="publish-btn-container">
          <van-button type="primary" round :disabled="formItemDisabled" class="publish-btn"
                      @click="onPublishSettings()">发布配置
          </van-button>
        </div>
      </div>
      <div v-if="activeTab==='2'">
        <!-- 定时开关机 -->
        <div class="card">
          <div class="card-title">定时开关机</div>
          <!-- 自动开关机功能 -->
          <div class="switch-item line">
            <div>
              <div class="switch-label">自动开关机</div>
              <div class="switch-desc">启用后设备将按计划自动开关机</div>
            </div>
            <label class="switch">
              <van-switch v-model="openCloseChecked" @change="onCheckedClose" size="24px" active-color="#ee0a24"
                          inactive-color="#dcdee0"/>
            </label>
          </div>
          <div class="schedule-section" v-if="openCloseChecked">
            <div class="subsection-title">⏰ 每周定时计划</div>
            <div>
              <div class="schedule-item" v-for="(item,index) in timeWeekData" :key="index">
                <div class="schedule-header">
                  <span class="schedule-title">{{ item.title }}</span>
                  <div class="switch" style="width: 42px; height: 24px;">
                    <van-switch v-model="item.checked" size="24px" active-color="#ee0a24" inactive-color="#dcdee0"/>
                  </div>
                </div>
                <div class="time-picker-group day-time-group" v-if="item.checked">
                  <div class="time-picker">
                    <div class="time-label">开机时间</div>
                    <div class="time-text">
                      <van-field
                          readonly
                          clickable
                          name="datetimePicker"
                          :value="item.startTime"
                          label=""
                          placeholder="点击选择时间"
                          @click="onTimeValuePicker(item.type,'s')"
                      >
                        <template #right-icon>
                          <van-icon name="underway-o"/>
                        </template>
                      </van-field>
                    </div>
                  </div>
                  <div class="time-picker">
                    <div class="time-label">关机时间</div>
                    <div class="time-text">
                      <van-field
                          readonly
                          clickable
                          name="datetimePicker"
                          :value="item.endTime"
                          label=""
                          placeholder="点击选择时间"
                          @click="onTimeValuePicker(item.type,'e')"
                      >
                        <template #right-icon>
                          <van-icon name="underway-o"/>
                        </template>
                      </van-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="list-btn">
                <van-button type="primary" size="normal" :disabled="formTimeDisabled" color="rgb(238, 10, 36)"
                            @click="onButtonSetting('开')">确认定时计划
                </van-button>
              </div>
            </div>
          </div>
        </div>
        <!-- 雷达与直播设置 -->
        <div class="card">
          <div class="card-title">雷达<!--与直播-->设置</div>
          <!-- 雷达功能 -->
          <div class="switch-item">
            <div>
              <div class="switch-label">雷达功能</div>
              <div class="switch-desc">开启后可检测周边信号</div>
            </div>
            <div class="switch">
              <van-switch v-model="ridChecked" size="24px" active-color="#ee0a24" inactive-color="#dcdee0"/>
            </div>
          </div>
          <div class="switch-item-tit">
            <div class="switch-label">问候间隔</div>
          </div>
          <div class="switch-item-box">
            <van-field type="number" style="width:80%;" :max="300" :min="30"
                       :error-message="gapValue < 30 || gapValue > 300 ? '问候间隔必须在30秒到300秒之间' : ''"
                       v-model="gapValue"></van-field>
            <span>秒</span>
          </div>
          <div class="switch-item-tit">
            <div class="switch-label">最大检测距离</div>
          </div>
          <div class="switch-line">
            <div class="line-box">
              <el-slider v-model="maxDistinct" :max="6" :min="1" :show-tooltip="false"></el-slider>
            </div>
            <div class="line-number"><span>{{ maxDistinct }}</span>米</div>
          </div>
          <div style="margin-top: 20px">
            <van-button type="primary" round :disabled="formItemDisabled" class="publish-btn" @click="onRadar()">确定
            </van-button>
          </div>
          <!-- 开奖直播 -->
          <!--              这块功能暂时先不做-->
          <!--              <div class="switch-item">-->
          <!--                <div>-->
          <!--                  <div class="switch-label">自动播放开奖直播</div>-->
          <!--                  <div class="switch-desc">开奖时段自动切换至直播画面</div>-->
          <!--                </div>-->
          <!--                <div class="switch">-->
          <!--                  <van-switch v-model="autoChecked" size="24px"  active-color="#ee0a24" inactive-color="#dcdee0" />-->
          <!--                </div>-->
          <!--              </div>-->
        </div>

        <!-- 设备音量配置 -->
        <div class="card">
          <div class="card-title">设备音量配置</div>
          <div class="switch-item-box">
            <div class="switch-label">设备音量</div>
          </div>
          <div class="switch-line">
            <div class="line-box">
              <el-slider v-model="playbackVolume" :show-tooltip="false"></el-slider>
            </div>
            <div class="line-number"><span>{{ playbackVolume }}</span>%</div>
          </div>
          <div style="margin-top: 20px">
            <van-button type="primary" round :disabled="formItemDisabled" class="publish-btn" @click="onSubmitAudio()">
              确定
            </van-button>
          </div>
        </div>
        <!-- 代销者二维码 -->
        <div class="card">
          <div class="card-title">代销者二维码</div>
          <div class="switch-item">
            <div>
              <div class="switch-label">上传代销者二维码（必须为正方形图片）</div>
              <div class="switch-desc">上传代销者的微信二维码，用于展示在屏幕上</div>
            </div>
            <!--            <div class="switch">-->
            <!--              <van-switch v-model="siteChecked" size="24px" active-color="#ee0a24" inactive-color="#dcdee0" />-->
            <!--            </div>-->
          </div>
          <div>
            <div class="upload-submit">
              <div>选择二维码图片</div>
              <div class="group-video">
                <div class="group-video-load">
                  <van-uploader v-model="fileListQr" :max-count="1" accept="image/*" :before-delete="getReadDelete1"
                                :after-read="afterRead1" :before-read="beforeRead1"/>
                </div>
              </div>
              <div class="form-buttons">
                <van-button round block plain color="#e62d2d" type="default" @click="onReloadSubmit">立即更新
                </van-button>
                <van-button round block type="primary" color="#e62d2d" @click="onQrCodeSubmit">确认上传</van-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
.wrap {
  display: flex;
  flex-direction: column;
  background: #f8f9fd;
  min-height: calc(100vh - 92px);

  .tabs {
    display: flex;
    height: 86px;
  }

  .tab-content {
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px;
    box-sizing: border-box;
    //background: red;
    .content-box {
      display: flex;
      flex-direction: column;
      //position: relative;
      //background: #e6a23c;
      .tabs-style {
        //position: absolute;
        //top: 0;
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        height: 70px;
        //position: absolute;
        //top: 190px;
        /deep/ .van-tabs {
          height: 100%;
        }

        /deep/ .van-tabs__wrap {
          height: 100%;
        }

        /deep/ .van-tabs--line {
          height: 100%;
        }

        /deep/ .van-tabs__nav {
          background: transparent;

        }

        /deep/ .van-tabs__nav--complete {
          padding-left: 0;
        }

        /deep/ .van-tab {
          margin-right: 20px;
          border-radius: 50px;
          background: #fff;
          padding: 0 30px;
          border: 2px solid #eee;
        }

        ///deep/ .van-tab:first-child {
        //  background: transparent;
        //  color: transparent;
        //  border-color: transparent;
        //  padding: 0;
        //  margin-right: 0;
        //}

        /deep/ .van-tab__text {
          font-size: 24px;
        }

        /deep/ .van-tab--active {
          border-radius: 50px;
          background: #e62d2d;
          color: #fff;

          .num-style {
            color: #fff;
            background: #c11f1f;
          }
        }

        /deep/ .van-tabs__line {
          height: 0;
        }

        .icon-style {
          font-size: 28px;
          margin-right: 5px;
        }

        .num-style {
          border-radius: 50%;
          padding: 3px 10px;
          font-size: 24px;
          color: #555;
          background: rgba(0, 0, 0, 0.1);
        }
      }

      //.choice-box{
      //position: absolute;
      //top: 80px;
      //width: 100%;
      //display: flex;
      //flex: 1;
      //flex-direction: column;
      //background: pink;
      //box-sizing: border-box;
      //height: calc(100vh - 80px - 70px );
      //overflow-y: auto;
      //.card{
      //overflow-y: auto;
      //background: red;
      //}
      //}
      .info-text {
        font-size: 24px;
        color: #666;
        background-color: #f8f9fd;
        padding: 10px;
        border-radius: 8px;
        margin-bottom: 16px;
        line-height: 1.6;
        height: 80px;

        span {
          font-weight: bold;
          font-size: 24px;
        }
      }
    }

    .carousel-settings {
      background-color: #f8f9fd;
      padding: 22px;
      display: flex;
      flex-direction: column;
      margin-bottom: 16px;

      /deep/ .van-button {

        margin-top: 20px;
        border-radius: 16px;

      }

      /deep/ .van-button__text {
        font-size: 28px;
      }

      .input-group {
        display: flex;
        flex-direction: row;

        span {
          display: flex;
          align-items: center;
        }

        /deep/ .van-cell {
          width: 68%;
          margin: 0 8px;
        }
      }

    }

    .carousel-set {
      padding: 12px;
    }

    .publish-btn-container {
      background-color: white;
      padding: 12px 0;
      margin-top: 16px;
    }

    .publish-btn {
      width: 100%;
      padding: 20px 16px;
      background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
      color: white;
      border: none;
      border-radius: var(--radius-md);
      font-size: 28px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.3s;
      box-shadow: 0 4px 12px rgba(230, 45, 45, 0.3);
    }

    .publish-btn:active {
      transform: scale(0.98);
      box-shadow: 0 2px 8px rgba(230, 45, 45, 0.3);
    }

    .info-text {
      font-size: 24px;
      color: #666;
      background-color: #f8f9fd;
      padding: 10px;
      border-radius: 8px;
      margin-bottom: 16px;
      line-height: 1.6;
      height: 80px;

      span {
        font-weight: bold;
        font-size: 24px;
      }
    }

    .playlist-card {
      background-color: white;
      border-radius: var(--radius-md);
      padding: 16px;
      margin-bottom: 16px;
      box-shadow: var(--shadow);
      border: 2px solid var(--primary-color);
    }

    .playlist-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;
    }

    .playlist-title {
      font-size: 28px;
      font-weight: 600;
      color: var(--primary-color);
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .playlist-count {
      background-color: var(--primary-color);
      color: white;
      padding: 2px 14px;
      border-radius: 50px;
      font-size: 24px;
    }

    .playlist-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
      border: 1px solid #ffe0e0;
    }

    .order-number {
      width: 38px;
      height: 38px;
      color: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 22px;
      font-weight: 600;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .colR {
      background-color: #e62d2d;
    }

    .colG {
      background-color: #ddd;
    }

    .remove-btn {
      width: 48px;
      height: 48px;
      background-color: #fff5f5;
      border: 1px solid #ffcccc;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 28px;
      color: #ff4444;
      margin-left: 18px;
    }

    .remove-btn:active {
      background-color: #ffe0e0;
      border-color: var(--primary-color);
    }

    .playlist-controls {
      display: flex;
      flex-direction: column;
      gap: 4px;
      margin-left: auto;
      margin-right: 8px;
    }

    .order-btn {
      width: 48px;
      height: 48px;
      background-color: white;
      border: 1px solid var(--border-color);
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 18px;
      color: var(--text-secondary);
    }

    .order-btn:active {
      background-color: var(--secondary-color);
      border-color: var(--primary-color);
      color: var(--primary-color);
    }

    .order-btn-disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }


    .duration-edit {
      display: flex;
      align-items: center;
      gap: 4px;

      .time-text {
        width: 40%;
        margin: 0 10px;
      }
    }

    .duration-edit input {
      width: 120px;
      padding: 4px 10px;
      border: 1px solid var(--border-color);
      border-radius: 4px;
      font-size: 22px;
      text-align: center;
    }

    .duration-edit span {
      font-size: 26px;
      color: var(--text-secondary);
    }

    .material-list {
      margin-top: 12px;
    }

    .material-list-auto {
      margin-top: 12px;
    }

    .material-icon-evolve {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 8px;
    }

    .m-a-t {
      display: flex;
      flex-direction: row;
    }

    .edit-evolve {
      display: inline-block;
      padding: 5px 15px;
      margin-left: 10px;
      background-color: #f0f4ff;
      border: 2px solid #667eea;
      border-radius: 12px;
      cursor: pointer;
      transition: all 0.2s;
      font-size: 34px;
      color: #667eea;
    }

    .del-evolve {
      padding: 5px 15px;
      margin-left: 10px;
      background-color: #fff5f5;
      border: 2px solid #f44336;
      border-radius: 12px;
      display: inline-block;
      transition: all 0.2s;
      font-size: 34px;
      color: #f44336;
    }

    .pending-icon {
      background-color: #fff3e0;
      color: #ff9800;
    }

    .failed-icon {
      background-color: #ffebee;
      color: #f44336;
    }

    .status-evolve {
      display: inline-flex;
      padding: 3px 10px;
      border-radius: 12px;
      font-weight: 500;
      align-items: center;
      gap: 4px;
    }

    .material-item-auto {
      background: #f8f9fd;
      display: flex;
      align-items: center;
      padding: 12px 12px 12px 4px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
    }

    .Pass {
      border-left: 6px solid #667eea;
    }

    .Pending {
      border-left: 6px solid #ff9800;
    }

    .Failed {
      border-left: 6px solid #f44336;
    }

    .material-item {
      display: flex;
      align-items: center;
      padding: 12px;
      border-radius: var(--radius-sm);
      margin-bottom: 8px;
    }

    .material-icon {
      width: 60px;
      height: 60px;
      background-color: #e0e0e0;
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 42px;
      margin-left: 12px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .material-icon-auto {
      width: 60px;
      height: 60px;
      background-color: #e0e0e0;
      border-radius: var(--radius-sm);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 42px;
      margin-left: 8px;
      margin-right: 12px;
      flex-shrink: 0;
    }

    .material-info {
      flex: 1;
      padding: 0 20px;
    }

    .material-info-auto {
      flex: 1;
      padding: 0 0 0 10px;
    }

    .material-name-auto {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 4px;
      word-break: break-word;

      span {
        padding: 4px;
        font-size: 22px;
      }

      //.gGeneral{
      //  background-color: #e3f2fd;
      //  color: #1976d2;
      //}
      //.pPersonal{
      //  background-color: #e3f2fd;
      //  color: #1976d2;
      //}
    }

    .material-name {
      font-size: 28px;
      font-weight: 500;
      margin-bottom: 4px;
      word-break: break-word;

      span {
        padding: 4px;
        font-size: 22px;
      }

      .gGeneral {
        background-color: #e3f2fd;
        color: #1976d2;
      }

      .pPersonal {
        background-color: #fff2fd;
        color: #ff9800;
      }
    }

    .material-meta {
      font-size: 24px;
      color: #666;

      span {

        font-size: 24px;
      }
    }

    .material-switch {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      margin-left: 12px;
    }

    .material-switch-auto {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 4px;
      margin-left: 12px;
    }

    .material-switch-label {
      font-size: 22px;
      color: #666;
    }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: var(--text-light);
    }

    .empty-icon {
      font-size: 68px;
      margin-bottom: 12px;
    }

    .empty-text {
      font-size: 24px;
    }

    .check-item {
      background-color: #fff5f5;
    }

    .new-item {
      background-color: #f8f9fd;

    }

    .new-item-auto {
      //background-color: #f8f9fd;

    }
  }

}

.switch-item-box {
  display: flex;
  flex-direction: row;

  .switch-label {
    display: flex;
    font-size: 26px;
    margin-bottom: 50px;
    //color: var(--text-color);
  }

  span {
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
}

.switch-line {
  padding: 0 20px 0 10px;
  display: flex;
  flex-direction: row;

  .line-box {
    width: 70%;
  }

  .line-number {
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;

    span {
      color: var(--primary-color);
      font-size: 30px;
      font-weight: bold;
      padding-right: 10px;
    }
  }
}

.switch-item-tit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .switch-label {
    display: flex;
    font-size: 26px;
    //color: var(--text-color);
  }
}

.line {
  border-bottom: 2px solid #eee;
}

.switch-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 0;

  .switch {
    display: flex;

    .van-switch {
      background: #4caf50;
    }
  }

  .switch-label {
    display: flex;
    font-size: 26px;
    //color: var(--text-color);
  }

  .switch-desc {
    display: flex;
    font-size: 24px;
    //color: var(--text-secondary);
    margin-top: 4px;
  }
}

.switch-item:last-child {
  border-bottom: none;
}

///deep/.van-switch{
//  width: 1.6em;
//}
///deep/.van-switch__node{
//  height: 1.3em;
//  width: 1.3em;
//  left: 4px;
//  top: 4px;
//}

.schedule-section {
  margin-top: 16px;
  padding: 16px 0 0 0;

  .subsection-title {
    padding-bottom: 16px;
  }

  .list-btn {
    padding-top: 20px;

    /deep/ .van-button {
      width: 100%;
      border-radius: 16px;
    }

    /deep/ .van-button__text {
      font-size: 28px;
    }
  }
}

.schedule-item {
  background-color: #f8f9fd;
  border-radius: 8px;
  padding: 12px 20px;
  margin-bottom: 18px;
}

.schedule-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.schedule-title {
  font-size: 24px;
  font-weight: 500;
  color: var(--text-color);
}

.time-picker-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.time-picker {
  flex: 1;
}

.time-label {
  font-size: 26px;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.time-input {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 26px;
  color: var(--text-color);
}

/deep/ .van-cell {
  padding: 14px 14px;
  font-size: 24px;
  border: 2px solid #eee;
  border-radius: 12px;
}

/deep/ .van-field__control:read-only {
  font-size: 24px;
}

.inner-diag {
  padding: 30px 30px 0;
  box-sizing: border-box;
  border-radius: 30px;
  display: flex;
  flex-direction: column;

  //----


  //-----
  .fixed-close {
    position: absolute;
    right: 50px;
    top: 1px;
    font-size: 50px;
    color: #999;
  }

  .upload-requirements {
    padding: 12px;
    background: linear-gradient(135deg, #f0f4ff, #f8f9ff);
    border-radius: var(--radius-sm);
    border-left: 3px solid #667eea;
    margin-bottom: 16px;

    .req-title {
      font-size: 26px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }

  .form-commit {
    font-size: 24px;
    margin-bottom: 20px;

    /deep/ .van-cell {
      font-size: 24px;

    }

    /deep/ .van-field__control {
      font-size: 24px;

    }
  }


  .inner-title {
    display: flex;
    font-weight: bold;
    justify-content: center;
    font-size: 36px;
    padding-top: 60px;
    box-sizing: border-box;
  }

  .inner-txt {
    display: flex;
    justify-content: center;
    color: #666;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .inner-btn {
    display: flex;
    justify-content: space-between;
    padding: 50px 40px 0;

    .block-btn {
      width: 46%;

      /deep/ .van-button__text {
        font-size: 28px;
      }
    }

    .font {
      background: #f5f6fa;

      /deep/ .van-button__text {
        color: #666;
        font-size: 28px;
      }
    }
  }
}

/deep/ .el-slider__runway {
  height: 0.28rem;
  border-radius: 10px;
}

/deep/ .el-slider__button {
  height: 0.6rem;
  width: 0.6rem;
  background: var(--primary-color);
  border: 0.08rem solid #fff;
}

/deep/ .el-slider__bar {
  height: 0.28rem;
  border-radius: 10px;
  background: var(--primary-color);

}

.upload-submit {
  display: flex;
  background: #f8f9fd;
  padding: 20px;
  flex-flow: column;
}

.group-video {
  //border: 1px dashed #afafaf;
  border-radius: 10px;
  //height: 37vw;
  //width: 37vw;
  //background: #2196f3;
  margin-top: 20px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 200px;
    width: 200px;
    border: 2px dashed #e9e9e9;
    overflow: hidden;
    .upload-area {
      border-radius: 12px;
      padding: 40px 20px;
      text-align: center;
      background: transparent;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      /* 实现水平方向上居中 */
      justify-content: center;
      /* 实现垂直方向居中 */
      align-items: center;
      .file-input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
        background: transparent;
      }
      .icon-calm{
        position: absolute;
        width: 60px;
        height: 60px;
        font-size: 46px;
        color: #ddd;
      }
    }
    //.avatar-uploader{
    //  display: flex;
    //  width:100%;
    //  height:100%;
    //  align-items: center;
    //  justify-content: center;
    //  overflow: hidden;
    //  .el-upload{
    //    width:100%;
    //    height:100%;
    //    .avatar{
    //      width:100%;
    //      height:100%;
    //      img{
    //        width:100%;
    //        height:100%;
    //      }
    //    }
    //  }
    //}
    /deep/ .van-uploader {
      width: 100%;
      height: 100%;
      overflow: hidden;

    }

    /deep/ .van-uploader__wrapper {
      width: 100% !important;
      height: 100% !important;

    }

    /deep/ .van-uploader__preview {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__preview-image {
      width: 100% !important;
      height: 100% !important;
    }

    /deep/ .van-uploader__upload {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__file {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    .post-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      overflow: hidden;

      video {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }

    .group-load-item {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      padding: 70px 0;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: 28px;

      .video-icon-img {
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;

        img {
          width: 80px;
          height: 50px;
        }
      }

      .video-icon-txt {
        color: #ababab;
        padding-top: 20px;
      }
    }

    .aod {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}

.list-data {
  .filter-section {
    background-color: #f8f9fd;
    border-radius: var(--radius-md);
    padding: 12px;
    margin-bottom: 16px;

    .filter-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      align-items: flex-end;

      .filter-group {
        display: flex;
        flex-direction: column;

        .filter-label {
          color: var(--text-secondary);
          margin-bottom: 6px;
          font-weight: 500;
        }

        .filter-select {
          padding: 8px 12px;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          color: var(--text-color);
          background-color: white;
          cursor: pointer;
          transition: all 0.2s;
        }
      }
    }
  }
}

//.van-uploader{
//  width:100%;
//  height:100%;
//  top:0;
//  z-index:2;
//  /deep/.van-uploader__wrapper{
//    width:100% !important;
//    height:100% !important;
//  }
//  /deep/.van-uploader__upload{
//    position: absolute;
//    top: 0;
//    width:100% !important;
//    height:180px !important;
//    background: transparent;
//    margin: 5px;
//    //.van-icon{
//    //  display: none;
//    //}
//  }
//  /deep/.van-uploader__preview{
//    width: 100%;
//    height: 100%;
//    margin: 0;
//    .van-uploader__mask{
//      opacity: 0.5;
//      .van-uploader__loading{
//        .van-loading__spinner{
//          display:block;
//        }
//      }
//      .van-uploader__mask-icon{
//        color: red;
//        font-size: 80px;
//      }
//    }
//  }
//  /deep/.van-uploader__preview-image{
//    width: 100%;
//    height: 100%;
//
//  }
//  // /deep/.van-uploader__preview-image img{
//  //     object-fit:cover;//contain
//  // }
//}

/deep/ .van-uploader__preview-delete {
  height: 48px !important;
  width: 48px !important;
  z-index: 5;
}

/deep/ .van-uploader__preview-delete-icon {
  top: -8px !important;
  right: -8px !important;
  font-size: 60px !important;
}

/deep/ .van-uploader__file-name {
  color: transparent;
}
.progress-container {
  margin-top: 20px;
  display: none;
}
.progress-container.active {
  display: block;
}
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 14px;
  color: #2c3e50;
}
.progress-bar {
  height: 10px;
  background: #ecf0f1;
  border-radius: 5px;
  overflow: hidden;
  .progress-fill {
    height: 100%;
    background: #2ecc71;
    width: 0;
    transition: width 0.3s ease;
  }
}
</style>